export default __webpack_public_path__ + "static/media/605.1579f6c1.png";